import { gql } from 'apollo-boost';

const GET_EXPORT_BY_ID = gql`
  query GetExportById($exportId: ID!) {
    getExportById(exportId: $exportId) {
      status
      createdAt
      exportFiles {
        url
        createdAt
      }
    }
  }
`;

export { GET_EXPORT_BY_ID };
